<template>
  <div class="zkqq">
    <img src="./推广-头部.png" class="top-img"/>
    <span class="go-to-open" @click="openApp"></span>
    <div ref="zkqq">
      <div class="one-tip bg-gray">
        <div class="risk-warn-text">风险提示：任何软件都可能发生无法控制或不可预测的故障，为了确保交易不受影响，请务必安装多个软件以备紧急情况下使用！</div>
        <div class="flex-wrap">
          <div class="left">
              <p class="img-box"><img src="./东航快期小Q.png"/></p>
              <p class="mt-16">
                <!--TODO IOS暂时没有下载地址-->
                <a
                  href="https://apps.apple.com/cn/app/%E5%BF%AB%E6%9C%9F%E5%B0%8Fq/id1187762307">
                  <button class="button">IOS下载</button>
                </a>
              </p>
              <p class="mt-12">
                <a
                  href="https://www.shinnytech.com/ces">
                  <button class="button">安卓下载</button>
                </a>
              </p>
            </div>
            <div class="right">
              <p class="title">东航快期小Q</p>
              <div class="text letter-spacing"><p>
                以极简界面风格为客户提供流畅的期货和期权交易体验，除实现银期转账/资金查询/行情分析/下单撤单外，还支持交易所标准组合套利交易，内嵌上海期货交易所/能源交易所五档深度行情。</p></div>
            </div>

        </div>
       </div>
      <div class="one-tip">
        <div class="flex-wrap">
          <div class="left">
              <p class="title">东航易星Estar</p>
              <div class="text letter-spacing"><p>
                为客户提供全方位的期货行情/期货&期权交易/期权策略/多账户交易/云条件单/画线下单/止损止盈单服务,内嵌郑商所/上海黄金交易所。</p></div>
            </div>
            <div class="right">
              <p class="img-box"><img src="./东航易星Estar.png"></p>
              <p class="mt-16">
                <a href="https://itunes.apple.com/cn/app/estar易星/id1269479413?l=en&mt=8">
                  <button class="button">IOS下载</button>
                </a>
              </p>
              <p class="mt-12">
                <a href="https://fpub.kiiik.com/qhweb/xzzx/file/EstarAndroid.apk">
                  <button class="button">安卓下载</button>
                </a>
              </p>
            </div>

        </div>
       </div>
      <div class="one-tip bg-gray">
        <div class="flex-wrap">
          <div class="left">
              <p class="img-box"><img src="./东航金融二维码logo标准版.png"/></p>
              <p class="mt-16">
                <a href="http://m.kiiik.com/kiiikweixin/iphoned.jsp?cesfid=kiiik">
                  <button class="button">IOS下载</button>
                </a>
              </p>
              <p class="mt-12">
                <a href="https://m.cesfutures.com/kiiikweixin/appproNew/download.html">
                  <button class="button">安卓下载</button>
                </a>
              </p>
            </div>
            <div class="right">
              <p class="title">东航金融APP</p>
              <div class="text">
                <p>服务：开户、咨询、智能数据、交易策略、投资工具、蓝海密剑。</p>
                <p>行情：提供国内五大期货交易所及境外十余家期货交易所正版行情。</p>
                <p>交易：支持期货、期权交易。提供云条件单/画线下单/止损止盈单等服务。</p>
              </div>
            </div>

        </div>
       </div>
      <!--<div class="one-tip">
        <div class="left">
          <p class="title">掌控全球APP</p>
          <div class="text">
            <p>行情：中金所、上期所、大商所、郑商所、上证、深证、LME、CME、COMEX、NYMEX、CBOT、NYBOT、ICE、SGX、TOCOM。</p>
            <p>交易：国内期货、仓单融资、基金投资。</p>
            <p>服务：开户、咨询、智能数据、交易策略、投资工具、蓝海密剑。</p>
          </div>
        </div>
        <div class="right">
          <p class="img-box"><img src="./掌控全球APP.png"></p>
          <p class="mt-16">
            <a href="http://m.kiiik.com/kiiikweixin/ghts/iphoned.jsp">
              <button class="button">IOS下载</button>
            </a>
          </p>
          <p class="mt-12">
            <a href="http://m.kiiik.com/kiiikweixin/ghts/aphoned.jsp">
              <button class="button">安卓下载</button>
            </a>
          </p>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      appurl: {
        'name': '东航金融APP首页',
        'android': 'kiiikmobile://start.home',
        'ios': 'mobileplatform://HTML_FirstPage',
        'downloadurl': 'http://m.cesfutures.com/kiiikweixin/apppro/phoned.jsp'
      }
    }
  },
  components: {},
  mounted () {
    const docEl = document.documentElement
    const clientWidth = docEl.clientWidth
    if (!clientWidth) return
    if (clientWidth >= 375) {
      this.$refs.zkqq.style.fontSize = '100px'
    } else {
      this.$refs.zkqq.style.fontSize = 100 * (clientWidth / 375) + 'px'
    }
  },
  methods: {
    openApp: function () {
      let u = navigator.userAgent
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (isAndroid) {
        document.location = this.appurl.android
      }
      if (isiOS) {
        document.location = this.appurl.ios
      }
      setTimeout(() => {
        document.location = this.appurl.downloadurl
      }, 1000)
    }
  },
  computed: {}
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import './mixin.styl'

  .zkqq
    .top-img
      width 100%
      font-size 0
    .go-to-open
      display: block;
      position: absolute;
      top: 0;
      width: 21%;
      right: 0;
      height: 2.3%;
    p
      margin 0
      padding 0
      font-size 0
    a
      font-size 0
    .one-tip
      padding 5rem 2.5rem
      &:first-child
        padding 1rem 2.5rem 5rem
      &.bg-gray
        background-color #f7f7f7
      .flex-wrap
        display flex
      .left
        margin-right 2.5rem
      .img-box
        font-size 0
        img
          width 10rem
          height 10rem
      .mt-16
        line-height 0
        margin-top 1rem
      .mt-12
        margin-top 0.75rem
        line-height 0
      .button
        width 10rem
        height 3rem
        border 1px solid #2258b2
        border-radius 3px
        color #2258b2
        background #fff
        font-size(6px)
      .title
        font-weight bolder
        color #000
        font-size(8px)
        letter-spacing 2px
      .text
        margin-top 0.8rem
        color #000
        p
          font-size(6px)
      .letter-spacing
        letter-spacing 1px
        p + p
          margin-top 0.5625rem
    .risk-warn-text
      line-height 18px
      margin-bottom 10px
      text-align center
      font-size(6px)
      color red
      font-weight bold
</style>



// WEBPACK FOOTER //
// index.vue?f8b81bb8